import Immutable from 'immutable';

import actionTypes from 'src/constants/actionTypes';
import INITIAL_STATE from './initialState';

export default function (state = INITIAL_STATE, { payload, type }) {
  switch (type) {
    case actionTypes.AI__GENERATE_FROM_FILE_FAILURE:
      return state.withMutations(map => {
        map.set('errors', Immutable.fromJS(payload.errors));
        map.set('isActive', false);
        map.set('result', null);
      });

    case actionTypes.AI__GENERATE_FROM_FILE_START:
      return state.withMutations(map => {
        map.set('errors', null);
        map.set('isActive', true);
        map.set('result', null);
      });

    case actionTypes.AI__GENERATE_FROM_FILE_SUCCESS:
      return state.withMutations(map => {
        map.set('errors', null);
        map.set('isActive', false);
        map.set('result', Immutable.fromJS(payload.data));
      });

    default:
      return state;
  }
}
